/**
 * @internal
 */
export enum BuildSteps {
    toolbar = 'toolbar',
    group = 'group',
    button = 'button',
    params = 'params',
    settings = 'settings',
}
